import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RonCurrencyPipe } from '../core/pipes/ron-currency.pipe';
import { OverviewDialogComponent } from './dialog/dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DiscountPipe } from '../core/pipes/discount.pipe';
import { NgLet } from './directives/ng-let.directive';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { RainSystemCustomizationsComponent } from './rain-system-customizations/rain-system-customizations.component';
import { MatSelectModule } from '@angular/material/select';
import { CalculationTypesComponent } from './calculation-types/calculation-types.component';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { MatIconModule } from '@angular/material/icon';
import { ModelsSelectorComponent } from './models-selector/models-selector.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RoofCalculationsService } from './roof-calculations.service';

@NgModule({
  providers: [RoofCalculationsService],
  declarations: [
    RonCurrencyPipe,
    OverviewDialogComponent,
    ConfirmDialogComponent,
    DiscountPipe,
    NgLet,
    RainSystemCustomizationsComponent,
    CalculationTypesComponent,
    ModelsSelectorComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    RouterLink,
    NgxGoogleAnalyticsModule,
    MatIconModule,
    MatCheckboxModule,
  ],
  exports: [
    ReactiveFormsModule,
    RonCurrencyPipe,
    OverviewDialogComponent,
    DiscountPipe,
    NgLet,
    RainSystemCustomizationsComponent,
    CalculationTypesComponent,
    ModelsSelectorComponent,
  ],
})
export class SharedModule {}
